<template>
  <div id="app">
    <div v-if="this.$user.id > 0" class="app-auth-layout">
      <Navigation></Navigation>
      <main class="app-route-content">
        <router-view />
      </main>
    </div>
    <div v-if="this.$user.id == -1">
      <Login></Login>
    </div>
    <div class="startUp" v-if="this.$user.id == -2">
      <div class="subText">
        <img style="height: 15rem" src="@/assets/loading.gif" /><br />
        Warte auf start von<br />IAMS
      </div>
    </div>
    <Search v-if="$root.search == true"></Search>
    <RequestProcessing
      v-if="this.$root.requestProcessing.running"
    ></RequestProcessing>
    <div
      v-if="changelogVisible && this.$user.id > 0"
      class="changelog-overlay"
      @click.self="closeChangelog"
    >
      <section class="changelog-dialog">
        <header class="changelog-header">
          <div>
            <p class="changelog-kicker">Changelog</p>
            <h2 class="changelog-title">Was ist neu in {{ changelog.version }}?</h2>
          </div>
          <button type="button" class="changelog-close" @click="closeChangelog">
            Schliessen
          </button>
        </header>

        <p class="changelog-hint">
          Bitte bestaetige das Changelog. Danach wird es erst wieder angezeigt,
          wenn es eine neue Version gibt.
        </p>

        <pre class="changelog-content">{{ changelog.content }}</pre>

        <footer class="changelog-actions">
          <button type="button" class="btn btn-secondary" @click="closeChangelog">
            Spaeter
          </button>
          <button type="button" class="btn btn-primary" @click="confirmChangelog">
            Gelesen und bestaetigen
          </button>
        </footer>
      </section>
    </div>
    <SystemServerInfo
      v-if="!this.$serverUrl().includes('https://richter.myiams.de')"
    ></SystemServerInfo>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import Login from "@/views/user/Login.vue";
import Search from "@/views/overlayers/Search.vue";
import SystemServerInfo from "@/views/overlayers/SystemServerInfo.vue";
import RequestProcessing from "@/views/overlayers/RequestProcessing.vue";

export default {
  components: {
    Navigation,
    Login,
    Search,
    RequestProcessing,
    SystemServerInfo,
  },
  data: function () {
    return {
      user: this.$user,
      changelog: {
        version: "",
        checksum: "",
        content: "",
      },
      changelogVisible: false,
      changelogLoading: false,
      lastCheckedChangelogUserId: null,
    };
  },
  mounted() {
    document.title = 'Richter - MyIAMS';
    this.$root.apiRequest("/session", {}, (response) => {
      this.applySession(response.data.result);
    });
  },
  watch: {
    "user.id": function (newValue, oldValue) {
      if (newValue > 0 && newValue !== oldValue) {
        this.loadChangelogIfNeeded();
      }

      if (newValue <= 0) {
        this.changelogVisible = false;
        this.lastCheckedChangelogUserId = null;
      }
    },
    $route() {
      
    },
  },
  methods: {
    applySession: function (sessionData) {
      this.user.id = sessionData.id;
      this.user.username = sessionData.username;
      this.user.admin = sessionData.admin;
      this.user.lastReadChangelogChecksum =
        sessionData.lastReadChangelogChecksum;
    },
    loadChangelogIfNeeded: function () {
      if (this.user.id <= 0 || this.changelogLoading) {
        return;
      }
      if (this.lastCheckedChangelogUserId === this.user.id) {
        return;
      }

      this.changelogLoading = true;
      this.$root.apiRequest(
        "/changelog",
        {},
        (response) => {
          this.changelog.version = response.data.result.version;
          this.changelog.checksum = response.data.result.checksum;
          this.changelog.content = response.data.result.content;
          this.user.lastReadChangelogChecksum =
            response.data.result.userLastReadChangelogChecksum;
          this.changelogVisible = !!response.data.result.shouldShow;
          this.lastCheckedChangelogUserId = this.user.id;
          this.changelogLoading = false;
        },
        () => {
          this.changelogLoading = false;
        },
        true
      );
    },
    closeChangelog: function () {
      this.changelogVisible = false;
    },
    confirmChangelog: function () {
      this.$root.apiRequest(
        "/changelog/confirm",
        {},
        (response) => {
          this.user.lastReadChangelogChecksum = response.data.result.checksum;
          this.changelogVisible = false;
        },
        undefined,
        true
      );
    },
  },
};
</script>


<style>
#app {
  color: #2c3e50;
}

.app-auth-layout {
  min-height: 100vh;
  background: linear-gradient(135deg, #f3f6fa 0%, #e8eef6 100%);
}

.app-route-content {
  padding-top: 0.65rem;
}

.changelog-overlay {
  position: fixed;
  inset: 0;
  background: rgba(14, 23, 36, 0.55);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.changelog-dialog {
  width: min(900px, 100%);
  max-height: calc(100vh - 2rem);
  background: #fff;
  border: 1px solid #cfdae6;
  display: flex;
  flex-direction: column;
}

.changelog-header {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
  padding: 1rem 1rem 0.75rem;
  border-bottom: 1px solid #e0e8f0;
}

.changelog-kicker {
  margin: 0;
  font-size: 0.78rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #61788f;
}

.changelog-title {
  margin: 0.2rem 0 0;
  font-size: 1.45rem;
  color: #22384f;
}

.changelog-close {
  border: 1px solid #c7d5e2;
  background: #f4f8fb;
  color: #2d455f;
  padding: 0.35rem 0.7rem;
}

.changelog-hint {
  margin: 0;
  padding: 0.9rem 1rem 0;
  color: #556d86;
}

.changelog-content {
  margin: 0.9rem 1rem 0;
  padding: 1rem;
  border: 1px solid #d8e2ec;
  background: #f9fbfd;
  white-space: pre-wrap;
  overflow: auto;
  flex: 1;
  font-family: inherit;
  font-size: 0.96rem;
  line-height: 1.5;
}

.changelog-actions {
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

.startUp {
  height: 100vh;
  position: relative;
}
.startUp .subText {
  margin: 0;
  font-size: 4rem;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  text-align: center;
  transform: translate(-50%, -50%);
}
.bg-light {
  background-color: #f8f9fa;
}

b-btn {
  background-color: #007bff;
  color: white;
  border-radius: 0.25rem;
}

@media (max-width: 575px) {
  .app-route-content {
    padding-top: 0.45rem;
  }

  .changelog-header,
  .changelog-actions {
    flex-direction: column;
  }
}
</style>
